import { defineNuxtPlugin } from '#app';
import { Api } from '~/services/swagger/Api';

export default defineNuxtPlugin(nuxtApp => {
    const api = new Api();
    nuxtApp.provide('api', api);
});
